// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"83703d59","453":"9cbcf4e8"}[chunkId] + ".chunk.js";
};